import React, { useState, useEffect } from 'react';
import { Layout, Menu, Button, Drawer } from 'antd';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import {
  DashboardOutlined,
  TeamOutlined,
  LogoutOutlined,
  MenuOutlined,
  DownloadOutlined,
  SolutionOutlined,
  FileTextOutlined,
} from '@ant-design/icons';
import './Homepagecomponent.css';

const { Header, Sider, Content } = Layout;

const HomepageComponent = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [role, setRole] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      const mobileView = window.innerWidth <= 768;
      setIsMobileView(mobileView);
      setCollapsed(mobileView);
    };

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const storedRole = localStorage.getItem('role');

    if (token && storedRole) {
      setRole(storedRole);
    } else {
      navigate('/');
    }
  }, [navigate]);

  const openDrawer = () => setDrawerVisible(true);
  const closeDrawer = () => setDrawerVisible(false);

  const handleMenuClick = () => {
    if (isMobileView) closeDrawer();
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('userData');
    navigate('/');
  };

  const renderMenuItems = () => {
    if (role === 'admin') {
      return (
        <>
          <Menu.Item key="dashboard" icon={<DashboardOutlined style={{ color: '#fff' }} />} onClick={handleMenuClick}>
            <Link to="/dashboard">Dashboard</Link>
          </Menu.Item>
          <Menu.Item key="createcurrents" icon={<TeamOutlined style={{ color: '#fff' }} />} onClick={handleMenuClick}>
            <Link to="/createform">Create Currents</Link>
          </Menu.Item>
          <Menu.Item key="currents" icon={<TeamOutlined style={{ color: '#fff' }} />} onClick={handleMenuClick}>
            <Link to="/formdetails">Currents</Link>
          </Menu.Item>
          <Menu.Item key="staff" icon={<SolutionOutlined style={{ color: '#fff' }} />} onClick={handleMenuClick}>
            <Link to="/staff">Staff</Link>
          </Menu.Item>
          <Menu.Item key="received" icon={<DownloadOutlined style={{ color: '#fff' }} />} onClick={handleMenuClick}>
            <Link to="/receivedfrom">Received From</Link>
          </Menu.Item>
          <Menu.Item key="section" icon={<FileTextOutlined style={{ color: '#fff' }} />} onClick={handleMenuClick}>
            <Link to="/sectionfrom">Section From</Link>
          </Menu.Item>
        </>
      );
    } else if (role === 'user') {
      return (
        <>
        <Menu.Item key="dashboard" icon={<DashboardOutlined style={{ color: '#fff' }} />} onClick={handleMenuClick}>
            <Link to="/dashboard">Dashboard</Link>
          </Menu.Item>
        <Menu.Item key="createcurrents" icon={<TeamOutlined style={{ color: '#fff' }} />} onClick={handleMenuClick}>
          <Link to="/createform">Create Currents</Link>
        </Menu.Item>
        <Menu.Item key="currents" icon={<TeamOutlined style={{ color: '#fff' }} />} onClick={handleMenuClick}>
          <Link to="/formdetails">Currents</Link>
        </Menu.Item>
        </>
      );
    }
    return null;
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {!isMobileView && (
        <Sider
          className={`sidebar ${collapsed ? 'collapsed' : ''}`}
          width={250}
          collapsedWidth={50}
          collapsible
          collapsed={collapsed}
          breakpoint="md"
          onCollapse={(collapsed) => setCollapsed(collapsed)}
        >
          <div className="sidebar-header">
            <h4 className="logo">ASL</h4>
          </div>
          <Menu mode="inline" className="custom-menu" theme="dark">
            {renderMenuItems()}
            <Menu.Item key="logout" icon={<LogoutOutlined style={{ color: '#fff' }} />} onClick={handleLogout}>
              Logout
            </Menu.Item>
          </Menu>
        </Sider>
      )}

      <Layout>
        <Header className="header" style={{ padding: 0, width: '100%' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
              flexWrap: 'wrap',
              gap: '50px',
            }}
          >
            <div style={{ flexGrow: 1 }} />
            {isMobileView && (
              <Button
                icon={<MenuOutlined style={{ fontSize: '20px' }} />}
                onClick={openDrawer}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: 'white',
                  marginRight: '16px',
                  marginTop: '5px',
                }}
              />
            )}
          </div>
        </Header>

        <Drawer
          title="Menu"
          placement="left"
          onClose={closeDrawer}
          visible={drawerVisible}
          width={250}
          style={{ backgroundColor: '#242424', color: 'white' }}
        >
          <Menu mode="inline" style={{ backgroundColor: '#242424', color: 'white' }} theme="dark">
            {renderMenuItems()}
            <Menu.Item key="logout" icon={<LogoutOutlined style={{ color: '#fff' }} />} onClick={handleLogout}>
              Logout
            </Menu.Item>
          </Menu>
        </Drawer>

        <Content style={{ overflow: 'auto', height: 'calc(100vh - 64px)' }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default HomepageComponent;
